export default {"src":"/_next/static/media/header-glow.b44ff869.svg","height":1276,"width":1079};